import { useState } from "react";
import { toast } from "react-toastify";
import UserProfilePreviewModal from "../../../components/UserProfilePreviewModal";
import { toFarsiNumber } from "../../../custom/helpers";
import { formatJalali } from "../../challenges/jalaliDate";
import { useGroupApi } from "../groupApi";
import { GroupAvatar, ConfirmSheet } from "./ui";

export default function GroupMembers({ groupId, me, members, onChanged, onInvite }) {
  const { call } = useGroupApi();
  const [profile, setProfile] = useState(null);
  const [toRemove, setToRemove] = useState(null);
  const [busy, setBusy] = useState(false);

  const remove = async () => {
    setBusy(true);
    try {
      await call(`groups/${groupId}/members/${toRemove.user_id}`, { method: "DELETE" });
      toast.success("عضو از گروه حذف شد");
      onChanged();
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
      setToRemove(null);
    }
  };

  if (members === null) {
    return <div className="grpPanel" style={{ padding: 14 }}>{[0, 1, 2].map((i) => <div key={i} className="grpSkeleton" style={{ marginBottom: 10, height: 56 }} />)}</div>;
  }

  return (
    <div className="grpPanel">
      {members.length <= 1 && (
        <div className="grpEmpty">
          <span className="grpEmptyIcon">👥</span>
          <div className="grpEmptyTitle yekan">برای برنامه‌ریزی دسته‌جمعی، بقیه رو دعوت کن</div>
          {me.is_owner && (
            <button type="button" className="grpBtn" style={{ marginTop: 10 }} onClick={onInvite}>
              <span className="icon-iconuser-add"></span> دعوت عضو
            </button>
          )}
        </div>
      )}
      {members.map((m) => (
        <div className="grpMember" key={m.user_id}>
          <GroupAvatar name={m.name} size="md" />
          <div className="grpMemberInfo">
            <button type="button" className="grpMemberName" onClick={() => setProfile(m)}>
              {m.name}{m.is_me && " (شما)"}
            </button>
            {m.role === "owner" && <span className="grpBadge grpBadge-owner yekan">مدیر</span>}
            <div className="grpMemberMeta yekan">
              عضویت: {toFarsiNumber(formatJalali(m.joined_at, "DD MMMM YYYY"))}
              <span className={`grpBadge yekan ${m.can_edit_calendar ? "grpBadge-edit" : ""}`}>
                {m.can_edit_calendar ? "می‌تونه تقویم رو ویرایش کنه" : "فقط مشاهده تقویم"}
              </span>
            </div>
          </div>
          {me.is_owner && m.role !== "owner" && (
            <button type="button" className="grpIconBtn" aria-label="حذف عضو" onClick={() => setToRemove(m)}>
              <span className="icon-icondelete red-0"></span>
            </button>
          )}
        </div>
      ))}

      <UserProfilePreviewModal show={!!profile} onClose={() => setProfile(null)} userId={profile && profile.user_id} name={profile && profile.name} />

      {toRemove && (
        <ConfirmSheet
          title="حذف عضو"
          message={`${toRemove.name} از گروه حذف بشه؟ دیگه به گفتگو و تقویم گروه دسترسی نخواهد داشت.`}
          confirmLabel="آره، حذف کن"
          busy={busy}
          onConfirm={remove}
          onClose={() => setToRemove(null)}
        />
      )}
    </div>
  );
}
